module.exports = __webpack_public_path__ + "img/rate_star.37857ad3.svg";